const text = {
  'sk': {
    'nav': {
      'about': 'O nás',
      projects: 'Projekty',
      contact: 'Kontakt'
    },
    p: {
      leadAboutA: 'Firmu definujú jej ľudia. Aj preto je ',
      leadAboutB: 'moderná a flexibilná alternatíva vo svete IT. Či už pre vznikajúce riešenia, ako aj pre zavedené systémy.',
      cards: {
        stano: 'Od vedeckých výpočtových systémov až po webové aplikácie. Počas posledných dvoch rokov som sa venoval hlavne astroinformatike cez diplomovú prácu. ' +
          'V tomto obore aj pokračujem - som doktorand na informatike a aj ďalej úzko spolupracujem s astronómami na našej univerzite vo vývine komplexného systému na pozorovanie vesmírneho odpadu.',
        maco: 'V tvorbe webových aplikácií som ako doma. Okrem skúseností zo školy a z veľmi veľkého počtu vlastných projektov stojím aj za rôznymi väčšími aj menšími aplikáciami pre klientov. ' +
          'Svoju odbornosť potvrdzujem aj ako zamestnanec rôznych firiem zameraných od telekomunikácie až po vytváranie 3D vizualizácií pre robotov.',
        kalendariumTitle: 'Kalendárium',
        kalendarium: 'Komplexný systém manažovania podujatí pre Tlačovú agentúru Slovenskej Republiky.',
        laroksTitle: 'LAROKS',
        laroks: 'Webová stránka živnostníka - stavebnej, konzultačnej a projektovej firmy so sídlom v Žiline, LAROKS.',
        sdlcdTitle: 'Katalóg kriviek',
        sdlcd: 'Katalóg svetelných kriviek pre Fakultu matematiky, fyziky a informatiky Univerzity Komenského v Bratislave.',
        yourProject: 'Váš projekt môže byť ďalší. Neváhajte nás kontaktovať.'
      },
      leadProjects: 'Nič nám nie je cudzie. Riadime sa filozofiou, že v súčasnej dobe je dôležité mať široké zameranie. ' +
        'Hranice medzi jednotlivými IT zameraniami sa stenčujú a skúsenosti z jedného oboru sa veľakrát prenesú aj do druhého.'
    },
    buttons: {
      view: 'Zobraziť',
      visit: 'Navštíviť',
      contact: 'Kontaktovať'
    },
    ico: 'IČO',
    modalKalendarium: ' je verejnosti neprístupná. Z tohto dôvodu ukazujeme len stručný náhľad.'
  },
  'en': {
    'nav': {
      'about': 'About us',
      projects: 'Projects',
      contact: 'Contact'
    },
    p: {
      leadAboutA: 'A company is defined by its employees. That\'s why ',
      leadAboutB: 'is a modern and flexible alternative in the world of IT. Both for emerging solutions and for in-place systems.',
      cards: {
        stano: 'From scientific computational systems to web applications. I\'ve spent the last two years in Astroinformatics thanks my dissertation thesis. ' +
          'Besides developing web apps in my free time, I am also a doctoral student in Informatics and I closely work with astronomers at our university on a development of a complex system for space debris observations.',
        maco: 'Web application development is my home. Besides having experience from my exhausting studies and a vast number of my own projects, I\'m also responsible for both large and small applications for various clients. ' +
          'My expertise is confirmed by being employed in many well-known and established companies, ranging from telecommunications to creating 3D visualizations for robots.',
        kalendariumTitle: 'Calendarium',
        kalendarium: 'A complex system for managing event reporting for the News Agency of the Slovak Republic.',
        laroksTitle: 'LAROKS',
        laroks: 'A web page for a construction, consulting and planning company based in Žilina, LAROKS.',
        sdlcdTitle: 'Light curves database',
        sdlcd: 'A light curve databse for the Faculty of Mathematics, Physics and Informatics of Comenius University Bratislava.',
        yourProject: 'Your project could be next. Don\'t hesitate to contact us.'
      },
      leadProjects: 'Nothing is foreign to us. We employ a philosophy that in this age, more than anything it is important to have a wide focus. ' +
        'The boundaries between separate IT departments are thinning and expertise from one area is many times invaluable in another. '
    },
    buttons: {
      view: 'View',
      visit: 'Visit',
      contact: 'Contact'
    },
    ico: 'company registration number',
    modalKalendarium: ' is inaccessible to the public. From that reason we show only a short overview.'
  }
}

export default text
